import { render, staticRenderFns } from "./SimpleProduct.vue?vue&type=template&id=a609569e&scoped=true&"
import script from "./SimpleProduct.vue?vue&type=script&lang=js&"
export * from "./SimpleProduct.vue?vue&type=script&lang=js&"
import style0 from "./SimpleProduct.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./SimpleProduct.vue?vue&type=style&index=1&id=a609569e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a609569e",
  null
  
)

export default component.exports